import { gql } from "@apollo/client";

export const REGISTER_USER = gql`
  mutation signupByPhoneNumber($input: SignUpRequest!) {
    signupByPhoneNumber(input: $input)
  }
`;

export const LOGIN_USER = gql`
  mutation loginUser($input: LoginRequest!) {
    login(input: $input) {
      access_expiry
      access_token
      refresh_expiry
      refresh_token
      user {
        first_name
        last_name
        phone_number
      }
    }
  }
`;

export const LOGOUT_USER = gql`
  mutation logout {
    logout
  }
`;

export const SEND_CONTACT_SUPPORT_MAIL = gql`
  mutation SendContactSupportMail(
    $event_id: UUID!
    $input: ContactSupportMailInput!
  ) {
    sendContactSupportMail(event_id: $event_id, input: $input)
  }
`;

export const UPDATE_USER_PROFILE = gql`
  mutation updateUserProfile($input: UpdateUserProfileRequest!) {
    updateUserProfile(input: $input) {
      id
      title
      first_name
      last_name
      other_name
    }
  }
`;

export const GENERATE_PROFILE_IMAGE_PRESIGNED_URL = gql`
  mutation GenerateProfileImagePreSignedUrl($mediaType: String!) {
    generateProfileImagePreSignedUrl(mediaType: $mediaType) {
      upload_url
      file_uri
      expiry_time
      expiry_time_in_seconds
      user_id
    }
  }
`;

export const VERIFY_PHONE = gql`
  mutation verifyPhone($otp: String!, $phone: String!) {
    verifyPhone(otp: $otp, phone: $phone) {
      access_expiry
      access_token
      refresh_expiry
      refresh_token
      user {
        first_name
        id
        last_name
        phone_number
      }
    }
  }
`;

export const UPDATE_CHANGE_PASSWORD = gql`
  mutation changePassword($newPassword: String!, $oldPassword: String!) {
    changePassword(newPassword: $newPassword, oldPassword: $oldPassword)
  }
`;

export const SEND_FORGET_PASSWORD = gql`
  mutation sendForgetPassword($phone: String!) {
    sendForgetPasswordOTP(phone: $phone)
  }
`;

export const RESET_PASSWORD = gql`
  mutation resetPassword($otp: String!, $password: String!, $phone: String!) {
    resetPassword(OTP: $otp, password: $password, phone: $phone)
  }
`;

export const RESEND_VERIFY_PHONE_OTP = gql`
  mutation resendVerifyPhoneOTP($phone: String!) {
    resendVerifyPhoneOTP(phone: $phone)
  }
`;

export const BEGIN_PASSKEY_REGISTRATION = gql`
  mutation BeginPasskeyRegistration {
    beginPasskeyRegistration {
      session_token
      options
    }
  }
`;

export const FINISH_PASSKEY_REGISTRATION = gql`
  mutation FinishPasskeyRegistration($input: PasskeyFinishRequest!) {
    finishPasskeyRegistration(input: $input)
  }
`;

export const BEGIN_PASSKEY_LOGIN = gql`
  mutation BeginPasskeyLogin($identifier: String!) {
    beginPasskeyLogin(identifier: $identifier) {
      session_token
      options
    }
  }
`;

export const FINISH_PASSKEY_LOGIN = gql`
  mutation FinishPasskeyLogin($input: PasskeyFinishRequest!) {
    finishPasskeyLogin(input: $input) {
      refresh_token
      refresh_expiry
      access_token
      access_expiry
      user {
        id
        uuid
        title
        first_name
        last_name
        email
        phone_number
      }
    }
  }
`;

export const DELETE_ACCOUNT = gql`
  mutation DeleteAccount($password: String!) {
    deleteAccount(password: $password)
  }
`;
